import React, { createContext, useContext, useRef, useCallback } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const refreshCallbacksRef = useRef([]);

  const registerRefreshCallback = useCallback((callback) => {
    refreshCallbacksRef.current.push(callback);
    
    // Return unregister function
    return () => {
      refreshCallbacksRef.current = refreshCallbacksRef.current.filter(cb => cb !== callback);
    };
  }, []);

  const triggerRefresh = useCallback(() => {
    const callbacks = refreshCallbacksRef.current;
    callbacks.forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error('Error in refresh callback:', error);
      }
    });
  }, []);

  return (
    <NotificationContext.Provider value={{ registerRefreshCallback, triggerRefresh }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationRefresh = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationRefresh must be used within NotificationProvider');
  }
  return context;
};
